// extracted by mini-css-extract-plugin
export default {"container":"Pp-z","ratingLayout":"Qp-z","ratingLabel":"Rp-z","nonInteractiveRatingLabel":"Sp-z"};